import {
  GET_MESSAGES_BY_IID,
  GetMessagesByIidApi,
  GO_TO_MESSAGE_BY_IID,
  GoToMessageByIidApi,
} from '@weblite-wapps/protocol'
import { wappSubscription } from '$logic/wapp-communication/helper/subscription-handler'
import { openRoom } from '$logic/opened-room'
import { getMessageByIid } from '$logic/message'

wappSubscription.subscribe<GetMessagesByIidApi>(
  GET_MESSAGES_BY_IID,
  async payload => {
    if (!payload.iids?.length) return []

    return Promise.all(
      payload.iids.map(iid => getMessageByIid(payload.roomId, iid)),
    )
  },
)

wappSubscription.subscribe<GoToMessageByIidApi>(
  GO_TO_MESSAGE_BY_IID,
  async payload => {
    await openRoom(payload.roomId, payload.msgIid)
  },
)
